import React from 'react';
import './MFAReconfigure.css';
import mfaimage from "../../assets/images/mfa/mfa-image.svg";
import { useNavigate } from "react-router-dom";
import APIManager from '../../Services/ApiManager/ApiManager';

const MFAReconfigure = () => {
  const navigate = useNavigate();
  const handleGenerateKey = async () => {
    APIManager.getAssociateSoftwareToken()
      .then((json) => {
        const data = json;

        if (!data.secretCode) {
          throw new Error("Invalid response format");
        }

        let secret;

        // Handle both raw base32 secret and otpauth URI formats
        if (data.secretCode.startsWith('otpauth://')) {
          const urlParts = data.secretCode.split('?');
          const params = new URLSearchParams(urlParts[1]);
          secret = params.get('secret');
        } else {
          // API returned a raw base32 secret directly
          secret = data.secretCode;
        }

        if (!secret) {
          throw new Error("Secret key not found in response");
        }

        const issuer = encodeURIComponent("HARMAN Ignite");
        const accountName = encodeURIComponent("MFA Account");

        // Create a properly formatted otpauth URI
        const fixedSecretCode = `otpauth://totp/${issuer}:${accountName}?secret=${secret}&issuer=${issuer}`;

        // Update the data with fixed URI
        const fixedData = {
          ...data,
          secretCode: fixedSecretCode,
          originalSecretCode: data.secretCode,
          secret: secret
        };

        navigate("/ui/qr-code-page", { state: { qrData: fixedData } });
      })
      .catch((err) => {
        console.error(err.message || "Failed to generate secret key. Please try again.");
      });
  };

  return (
    <div className="mfa-page">
      <div className="mfa-container">
        <div className="logo-section">
          <img src={mfaimage} alt="ready-link-marketplace" className="logo" />
        </div>
        <div className="heading-section">
          <span className="mfa-heading">
            Reconfigure Multi-factor authentication (MFA)
          </span>
          <span className="mfa-subHeading">Reconfigure MFA by generating the secret key.
          </span>
        </div>
        <button className="generate-btn" onClick={handleGenerateKey}>
          Generate Secret Key
        </button>
      </div>
      <div className="footer-container">
        <p className="footer-text">
          Copyright © 2020 HARMAN International. All Rights Reserved.
        </p>

        <p className="footer-text">
          Need help? Please contact us at{" "}
          <a href="mailto:IgniteDevSupport@Harman.com" className="footer-link">
            IgniteDevSupport@Harman.com
          </a>
        </p>
        <p href="/developer-agreementDeveloper Agreement">Developer Agreement
        </p>
      </div>
    </div>
  )
}

export default MFAReconfigure;